import Icon from '../components/Icon.vue'

Icon.register({
  feather: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M467.1 44.8c50.6 50.5 61.7 124.9 16.3 199.4l-131.5 43.8h97.8c-9.9 10.7 3.7-3.1-46.3 46.9l-147.6 49.1h98.2c-75 73.1-194.5 70.7-246.8 54.9l-66.1 66c-9.4 9.4-24.6 9.4-34 0s-9.4-24.6 0-33.9l259.5-259.3c6.3-6.3 6.3-16.4 0-22.6s-16.4-6.3-22.6 0l-178.4 178.3c-6.8-60.3 3.2-150.8 63.6-211.2 24.8-24.7 7.1-7.1 85.8-85.7 90.6-90.5 189.7-88.2 252.3-25.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/feather.js
// module id = 1321
// module chunks = 0